const Footer = () => {
  return (
    <footer id="contacto">
      <div class="contenedor footer-content">
        <div class="contact-us">
          <h2 class="brand">Alexis Bipoular</h2>
          <p>Una Expedición a los Origines de la Cocina</p>
        </div>
        <div class="social-media">
          <a href="http://www.facebook.com" class="social-media-icon">
            <i class="bx bxl-facebook"></i>
          </a>
          <a href="http://www.twitter.com" class="social-media-icon">
            <i class="bx bxl-twitter"></i>
          </a>
          <a href="http://www.instagram.com" class="social-media-icon">
            <i class="bx bxl-instagram"></i>
          </a>
        </div>
      </div>
      <div class="line"></div>
    </footer>
  );
};

export default Footer;
